export default __webpack_public_path__ + "static/media/uploadIcon.0c729ff1.svg";